<script lang="ts">
    import { DesignEditor } from '$src/application/designs/DesignEditor';
    import { onMount, onDestroy, setContext } from 'svelte';
    import TopViewCanvas from './editor/TopViewCanvas.svelte';
    import SceneViewCanvas from './editor/SceneViewCanvas.svelte';
    import { GripHorizontal, GripVertical } from 'lucide-svelte';
    import { Pane, PaneGroup, PaneResizer } from 'paneforge';
    import TopViewTools from './views/main/TopViewTools.svelte';
    import SideViewCanvas from './editor/SideViewCanvas.svelte';

     const editor = new DesignEditor();

     setContext('editor', editor);

</script>

<div id="main-container" class="main-layout">
    <div class="main-menu-layout">
        <div id="info-zone">
            info
        </div>
        <div id="step-zone">
            step
        </div>
        <div id="global-action-zone">
            global action
        </div>
    </div>
    <PaneGroup direction="horizontal" class="flex-1 flex overflow-hidden">
        <Pane defaultSize={50} minSize={5} maxSize={70} class="flex-1 flex flex-col overflow-hidden">
            <div id="tool-layout">
                <div class="tools-primary-layout">

                </div>
                <div class="tools-secondary-layout">

                </div>
            </div>
            <div class="main-view-layout">
                <TopViewTools />
                <TopViewCanvas />
            </div>
        </Pane>
        <PaneResizer class="relative flex w-2 items-center justify-center bg-input">
            <div class="z-10 flex h-7 w-5 items-center justify-center rounded-sm border bg-input">
                <GripVertical />
            </div>
        </PaneResizer>
        <Pane defaultSize={30} minSize={5}>
            <PaneGroup direction="vertical">
                <Pane defaultSize={50} minSize={10}>
                    <SceneViewCanvas />
                </Pane>
                <PaneResizer class="relative flex h-2 items-center justify-center bg-input">
                    <div class="z-10 flex h-5 w-7 items-center justify-center rounded-sm border bg-input">
                        <GripHorizontal />
                    </div>
                </PaneResizer>
                <Pane defaultSize={50} minSize={10}>
                    <SideViewCanvas />
                </Pane>
            </PaneGroup>
        </Pane>
        <PaneResizer class="relative flex w-2 items-center justify-center bg-input">
            <div class="z-10 flex h-7 w-5 items-center justify-center rounded-sm border bg-input">
                <GripVertical />
            </div>
        </PaneResizer>
        <Pane defaultSize={20} minSize={10} maxSize={40}>

        </Pane>
    </PaneGroup>
</div>

<style>
    .main-layout {
        height: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
    }

    .main-menu-layout {
        height: 48px;
        background-color: #222222;
        display: grid;
        grid-template-columns: minmax(200px, min-content) minmax(min-content, auto) minmax(min-content, auto);
        color: #FFFFFF;
        z-index: 10;
    }

    .tools-primary-layout {
        height: 35px;
        background-color: #333333;
        z-index: 10;
    }

    .main-view-layout {
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
    }
</style>